import { Institution } from '../institution'

class Delegate {
  constructor(options = {}) {
    options = options || {}
    this.id = options.id
    this.barcode = options.barcode
    this.biography = options.biography
    this.displayName = options.displayName
    this.email = options.email
    this.firstName = options.firstName
    this.institution = Institution.init(options.institution)
    this.lastName = options.lastName
    this.middleName = options.middleName
    this.registrationId = options.registrationId
    this.title = options.title
  }

  // Class methods
  static init(options) {
    if (options instanceof Delegate) {
      return options
    }
    const instance = new Delegate(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return (!!this.firstName && !!this.lastName) || !!this.displayName
  }
}

export default {
  Delegate
}
export {
  Delegate
}
